import React from 'react';
import axios from 'axios';
import { Alert, Button } from 'antd';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn';
import { loadSkippedSteps } from '../onboardingSteps';
import { INSTITUTION_TERMS } from '../institutionCopy';

var CryptoJS = require('crypto-js');

function getSaccoId() {
  if (!localStorage.getItem('sacco')) {
    return '';
  }
  return CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(
    CryptoJS.enc.Utf8
  );
}

class OnboardingBanner extends React.Component {
  state = {
    visible: false,
    progressPercent: 0,
    loading: true,
  };

  componentDidMount() {
    this.checkProgress();
  }

  checkProgress = () => {
    const saccoId = getSaccoId();
    if (!saccoId || !this.props.branchManager) {
      this.setState({ loading: false, visible: false });
      return;
    }

    const skipped = loadSkippedSteps(saccoId);
    const form_data = new FormData();
    form_data.append('sacco', saccoId);
    form_data.append('skipped_steps', JSON.stringify(skipped));

    axios
      .post(`${serverconfig.backendserverurl}/customqueries/get_onboarding_progress`, form_data)
      .then((res) => {
        const progress = res.data;
        this.setState({
          loading: false,
          visible: !progress.client_onboarding_done,
          progressPercent: progress.progress_percent || 0,
        });
      })
      .catch(() => {
        this.setState({ loading: false, visible: false });
      });
  };

  render() {
    if (this.state.loading || !this.state.visible) {
      return null;
    }

    return (
      <Alert
        type="warning"
        showIcon
        closable
        style={{ marginBottom: 16 }}
        message={INSTITUTION_TERMS.onboardingInProgress}
        description={
          <span>
            {this.state.progressPercent}% complete. Continue the guided wizard to finish migrating
            your data.
            {' '}
            <Link to="/dataonboarding/">
              <Button type="link" size="small" style={{ padding: 0 }}>
                Open onboarding wizard
              </Button>
            </Link>
          </span>
        }
        onClose={() => this.setState({ visible: false })}
      />
    );
  }
}

export default OnboardingBanner;
